import { UUID } from '../uuid.model';

export class Parcours {
  constructor(
    public readonly id: UUID,
    public readonly position: number
  ) {}

  public static hydrate(obj: Parcours): Parcours {
    return new Parcours(obj.id, obj.position);
  }
}
